import { str } from 'envalid';

export class AudioTranscriptionEnvConfig {
  private static readonly schema = {
    OPENAI_API_KEY: str({
      desc: 'OpenAI API key for audio transcription (Whisper API)',
      example: 'sk-...',
    }),
  };

  private constructor() {}

  public static getSchema() {
    return AudioTranscriptionEnvConfig.schema;
  }
}
